import * as moment from 'moment';
import {OnChanges, IChangeIndication} from '../../common/common.types';
import {IHydrodataTimeseries, IHydrodataDatum} from '../../hydromet/timeseries/timeseries.controller';
import IOrganizationApi from '../../api/organization-api.service';
const HC_more: any = require('highcharts-more');

const Highcharts:any = require('highcharts');
HC_more(Highcharts)
const exporting: any = require('highcharts/modules/exporting');
exporting(Highcharts);
const noDataToDisplay: any = require('highcharts/modules/no-data-to-display');
noDataToDisplay(Highcharts);

export default class TimeseriesNewController {
	static $inject = ['$translate', 'organizationApi', '$window'];

	private chartOptions: any = {};
	private timeseries: IHydrodataTimeseries[];
	private hydrodataType: string;
	private yAxisLabel: string;
	private yearType: string;
	private CURRENT_HYDROYEAR: number;
	    

	constructor(
		private $translate:ng.translate.ITranslateService,
		private organizationApi: IOrganizationApi,
		private $window: ng.IWindowService,
	) {
		this.organizationApi
			.getOrganization(Number.parseInt(this.$window.localStorage.getItem('currentOrgId')))
				.then((org) => {
					this.yearType = org.yearType;
					if (org.yearType === "hydro_year") {
						this.CURRENT_HYDROYEAR = 
							moment().month() >= 9 ? moment().year() + 1 : moment().year();
					} else if (org.yearType === "calendar_year") {
						this.CURRENT_HYDROYEAR = moment().year();
					}
					
				});

		switch(this.hydrodataType) {
			case 'discharge':
				this.yAxisLabel = this.$translate.instant('Q_M3_S');		
				break;
			case 'precipitation':
				this.yAxisLabel = this.$translate.instant('MM_DAY');
				break;
			case 'temperature':
				this.yAxisLabel = '°C';
				break;
			case 'snowData':
				this.yAxisLabel = this.$translate.instant('MEAN_CATCHMENT_NDSI') + ' [%]';
				break;
			default:
				break;
		}
	}

	$onChanges(changes: IChangeIndication) {
		this.timeseries = this.timeseries || [];
	  	this.prepareChartOptions();
	}

	private normalizeDate(date: moment.Moment): Date { 
	  date = date.clone();
	  if (this.yearType === "hydro_year") {
	  	if (date.month() < 9) {
	  	  date.year(this.CURRENT_HYDROYEAR);
	  	} else {
	  	  date.year(this.CURRENT_HYDROYEAR - 1);
	  	}
	  } else {
	  	date.year(this.CURRENT_HYDROYEAR);
	  }
	  
	  return date.toDate();
	}

	private formatTimeseries() {
		return this.timeseries.map((series:IHydrodataTimeseries, index: number) => {
			let color: string;

			if (series.highlighted) {
				color = '#000'
			}
			if (series.current) {
				color = '#C40000'
			}

			if (series.id === "SD") {
				return {
					name: series.label,
					data: _.sortBy(series.data.map((datum: IHydrodataDatum) => {
						return {
							x: this.normalizeDate(datum.date),
							low: datum.hydrodata[1],
							high: datum.hydrodata[0],
							name: moment(datum.date).format('MMMM DD, YYYY')
						}
					}), 'x'),
		
					lineWidth: 0,
					color: "#aaa",
					type: "arearange",
					zIndex: index,
					fillOpacity: 0.2,
					marker: {
						enabled: false
					},
				}
			} else {
				return {
					name: series.label,
					data: _.sortBy(series.data.map((datum: IHydrodataDatum) => {
						return {
							x: this.normalizeDate(datum.date),
							y: datum.hydrodata,
							name: moment(datum.date).format('MMMM DD, YYYY')
						}
					}), 'x'),
					visible: index > (this.timeseries.length - 5),
					lineWidth: series.highlighted ? 2 : 1,
					color: color,
					type: "line",
					zIndex: index
				}
			}
			
		}).reverse();
	}

	prepareChartOptions() {
			this.chartOptions = {

				credits: {
				    enabled: false
				},
				legend: {
				    enabled: true,
				    layout: 'vertical',
				    align: 'right',
				    verticalAlign: 'top',
				    itemMarginTop: 10
				},
				title: {
				    text: ''
				},
				exporting: {
				    buttons: {
				        contextButton: {
				            x: -145,
				            y: - 5
				        }
				    },
				    sourceWidth:1000
				},
				chart: {
					height: 500
				},
				options: {
					chart: {
						type: 'StockChart'
					},
					navigator: {
						enabled: true
					}
				},
				tooltip: {
				    valueDecimals: 2,
				    pointFormat: 
				    	'<span style="color:{point.color}">\u25CF</span> {series.name} - ' + (this.hydrodataType === 'snowData' ? this.$translate.instant('MEAN_CATCHMENT_NDSI') : this.hydrodataType) + ': <b>{point.y}</b><br/>'
				},
				xAxis: {
					tickWidth: 1,
					tickLength: 20,
		        	title: {
		                text: this.$translate.instant('MONTH')
		            },
		            labels: {
		            	formatter: function () { console.log(this)
		            		return moment(this.value).add(2, "days").format('MMM');
		            	}
		            },
					tickPositioner: function () {
						var positions: any[] = [],
							tick = Math.floor(this.dataMin),
							increment = Math.ceil((this.dataMax - this.dataMin) / 12);

						if (this.dataMax !== null && this.dataMin !== null) {
							for (tick; tick - increment <= this.dataMax; tick += increment) {
								positions.push(tick);
							}
						}

						return positions;
					}
                },
				yAxis: {
		            title: {
		                text: this.yAxisLabel,
		                useHTML: true
		            }
		        },
		        
				useHighStocks: true,
				series: this.formatTimeseries(),
				plotOptions: {
					series: {
						turboThreshold: 10000,
						states: {
							hover: {
								lineWidth: 2
							}
						}
					}
				}
		    }

		    //Discharge [m3/s]
	}
}


/** WEBPACK FOOTER **
 ** ./app/hydromet/timeseriesNew/timeseries-new.controller.ts
 **/